import React, { useState } from 'react';
import { FormControl, Select, MenuItem, Typography, Box } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

interface DateRangeSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({ value, onChange }) => {
  const dateRanges = [
    { value: '7', label: 'Last 7 Days' },
    { value: '30', label: 'Last 30 Days' },
    { value: '90', label: 'Last 90 Days' },
    { value: '365', label: 'Last 365 Days' },
  ];

  return (
    <Box>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
        Date Range
      </Typography>
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <Select
          value={value}
          onChange={e => onChange(e.target.value)}
          displayEmpty
          IconComponent={KeyboardArrowDown}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
            },
          }}
        >
          {dateRanges.map(range => (
            <MenuItem key={range.value} value={range.value}>
              {range.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default DateRangeSelector;
